import { render } from "./PathwaysManagePathways.vue?vue&type=template&id=17098a3c"
import script from "./PathwaysManagePathways.vue?vue&type=script&lang=js"
export * from "./PathwaysManagePathways.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/pathways/PathwaysManagePathways.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17098a3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17098a3c', __exports__)) {
    api.reload('17098a3c', __exports__)
  }
  
  module.hot.accept("./PathwaysManagePathways.vue?vue&type=template&id=17098a3c", () => {
    api.rerender('17098a3c', render)
  })

}


export default __exports__